import React from 'react'
import { Form, DatePicker } from 'antd'

function IdCardValidTo() {

	return <div className='textarea-holder'><Form.Item
		name={['metadata', 'idCard', 'idCardValidTo']}
		label={'Валидност на личната карта'}
		className='input-box'
		rules={[
			{
				validator: async (_, idCardValidTo) => {
					if (!idCardValidTo || idCardValidTo.length < 1) {
						return Promise.reject(
							new Error('Моля, въведи валидност на личната карта'),
						)
					}
				},
			}
		]}
	>
		<DatePicker
			className='input'
			format={'DD.MM.YYYY'}
		/>
	</Form.Item>
	</div>
}

export default IdCardValidTo
